module.exports = __webpack_public_path__ + "static/media/play-store-nl.cb8e9d8d.svg";